<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <p-tabView>
        <p-tabPanel header="Supplier To Be Confirmed">
          <p-table
            selectionMode="single"
            [value]="joblist"
            [rows]="0"
            [responsive]="true"
            [paginator]="false"
            rowHover="true"
            resizableColumns="true"
            (onRowSelect)="onRowSelect($event)"
            *ngIf="isLoaded; else loading"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="from.primaryAddress">From</th>
                <th pSortableColumn="to.primaryAddress">To</th>
                <th pSortableColumn="latestPickupDate">Latest Pickup</th>
                <th pSortableColumn="latestDropOffDate">Latest Dropoff</th>
                <th pSortableColumn="customerName">Customer</th>
                <th pSortableColumn="movementType">Movement Type</th>
                <th pSortableColumn="price">paid by customer</th>
                <th pSortableColumn="vehiclesNum">Vehicles</th>
                <th pSortableColumn="urgency">Urgency</th>
                <th pSortableColumn="stage">Stage</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td>{{ item.from.primaryAddress }}</td>
                <td>{{ item.to.primaryAddress }}</td>
                <td>{{ item.latestPickupDate | datex : 'ddd DD MMM HH:mm' }}</td>
                <td>{{ item.latestDropOffDate | datex : 'ddd DD MMM HH:mm' }}</td>
                <td>{{ item.customerName }}</td>
                <td>{{ item.movementType }}</td>
                <td>{{ item.price }}</td>
                <td>{{ item.vehiclesNum }}</td>
                <td>{{ item.urgency }}</td>
                <td>{{ item.stage }}</td>
              </tr>
            </ng-template>
          </p-table>
          <!--
                    <p-dataTabl selectionMode="single" [value]="joblist" [rows]="0"
                                 [responsive]="true" [paginator]="false" rowHover="true"
                                 resizableColumns="true" (onRowSelect)="onRowSelect($event)" 
                                 *ngIf="isLoaded; else loading">
                        <p-column field="from.primaryAddress" header="From" 
                                  [sortable]="tru" [editable]="false" [style]="{'width': '90%'}">
                            <ng-template pTemplate="body" let-item="rowData">
                                {{item.from.primaryAddress}}
                            </ng-template>
                        </p-column>
                        <p-column field="to.primaryAddress" header="To" 
                                  [sortable]="tru" [editable]="false" [style]="{'width': '90%'}">
                            <ng-template pTemplate="body" let-item="rowData">
                                {{item.to.primaryAddress}}
                            </ng-template>
                        </p-column>
                        <p-column field="latestPickupDate" header="Latest Pick-up" 
                                  [sortable]="tru" [editable]="false" [style]="{'width': '90%'}">
                            <ng-template pTemplate="body" let-item="rowData">
                                {{item.latestPickupDate | datex:'ddd DD MMM HH:mm'}}
                            </ng-template>
                        </p-column>
                        <p-column field="latestDropOffDate" header="Latest drop-off" 
                                  [sortable]="tru" [editable]="false" [style]="{'width': '90%'}">
                            <ng-template pTemplate="body" let-item="rowData">
                                {{item.latestDropOffDate | datex:'ddd DD MMM HH:mm'}}
                            </ng-template>
                        </p-column>
                        <p-column field="customerName" header="Customer" 
                                  [sortable]="tru" [editable]="false" [style]="{'width': '90%'}"></p-column>
                        <p-column field="" header="Movement Type" 
                                  [sortable]="tru" [editable]="false" [style]="{'width': '90%'}"></p-column>
                        <p-column field="price" header="paid by customer" 
                                  [sortable]="tru" [editable]="false" [style]="{'width': '90%'}"></p-column>
                        <p-column field="vehiclesNum" header="Vehicles" 
                                  [sortable]="tru" [editable]="false" [style]="{'width': '90%'}"></p-column>
                        <p-column field="" header="Urgency" 
                                  [sortable]="tru" [editable]="false" [style]="{'width': '90%'}"></p-column>
                        <p-column field="" header="Stage" 
                                  [sortable]="tru" [editable]="false" [style]="{'width': '90%'}"></p-column>

                    </p-dataTable>
                    -->
        </p-tabPanel>

        <p-tabPanel header="Awaiting start"></p-tabPanel>
        <p-tabPanel header="Live Now"></p-tabPanel>
        <p-tabPanel header="Completed Jobs"></p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>

<div class="ui-g" *ngIf="selecteditem">
  <div class="ui-g-12 card job-details-container">
    <job-details [job]="selecteditem"></job-details>
  </div>
</div>

<ng-template #loading>Loading...</ng-template>
